// Generate a configuration for every different brand
const config = {
    apiUrl: process.env.GATSBY_API_URL,
    teamId: process.env.GATSBY_TEAM_ID
};

export default config;
